export const ITRConstants = {

    POST_ITR_DOCUMENTS_REQUEST: 'POST_ITR_DOCUMENTS_REQUEST',
    POST_ITR_DOCUMENTS_SUCCESS: 'POST_ITR_DOCUMENTS_SUCCESS',
    POST_ITR_DOCUMENTS_FAILURE: 'POST_ITR_DOCUMENTS_FAILURE'
};